export default __webpack_public_path__ + "static/media/select-white.fe40eee7.svg";